import { Form, Modal, Select } from 'antd';
import styled from 'styled-components';
import { roleNameKoreanEnum, User } from '../../modules/auth';

const { Option } = Select;
const StyledDiv = styled.div``;

interface UpdateUserRoleModalProps {
  visible: boolean;
  member: User;
  updateUserRole: (value: any) => void;
  onCancel: () => void;
}

function UpdateUserRoleModal({
  visible,
  member,
  updateUserRole,
  onCancel,
}: UpdateUserRoleModalProps) {
  const [form] = Form.useForm();

  return (
    <StyledDiv>
      <Modal
        open={visible}
        title="사용자 권한 수정"
        okText="확인"
        cancelText="취소"
        onCancel={onCancel}
        onOk={() => {
          form
            .validateFields()
            .then((values) => {
              // form.resetFields();
              updateUserRole(values);
            })
            .catch((info) => {
              console.error('Validate Failed:', info);
            });
        }}
      >
        <>
          <Form
            layout="vertical"
            form={form}
            name="control-hooks"
            initialValues={{ ...member }}
          >
            <Form.Item
              name="roleName"
              label="사용자 권한"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select>
                <Option value="1">{roleNameKoreanEnum['1']}</Option>
                <Option value="2">{roleNameKoreanEnum['2']}</Option>
                <Option value="3">{roleNameKoreanEnum['3']}</Option>
              </Select>
            </Form.Item>
            <Form.Item
              name="isEnabled"
              label="사용자 접근허용"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select>
                <Option value={true}>예</Option>
                <Option value={false}>아니오</Option>
              </Select>
            </Form.Item>
          </Form>
        </>
      </Modal>
    </StyledDiv>
  );
}

export default UpdateUserRoleModal;
